import React, { useState, useRef } from "react";
import { Offcanvas, CloseButton, Button, Form } from 'react-bootstrap';
import XMenuList from "./XMenuList";
import { FaArrowUp } from 'react-icons/fa';
import { getFirestore, collection, getDocs, query, where } from 'firebase/firestore';
import { spinner } from "../utils/Helper";
import { toast } from 'react-toastify';
import glass from "../images/glass.png"

export function CreateDoc({ theme, onSuccess }) {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);

    return (
        <>
            <Button variant="outline-info" size="sm" onClick={() => setShow(true)}>+ New Item</Button>
            <XMenuList
                mode="create_only"
                theme={theme}
                show={show}
                onHide={handleClose}
                onDeleteSuccess={onSuccess}
            />
        </>
    );
}

export default function XMenu(props) {

    const { theme = 'dark' } = props;
    const isDark = theme === 'dark';
    
    // HYBRID STATE: Fall back to local state if parent isn't managing visibility
    const [localShow, setLocalShow] = useState(false);
    const isCanvasOpen = props.isOpen !== undefined ? props.isOpen : localShow;

    const [xSpecials, setXSpecials] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [showScrollTop, setShowScrollTop] = useState(false);
    const scrollRef = useRef(null);

    const isPublicView = props.public === true;

    const themeStyles = {
        backdrop: isDark ? "bg-dark adminBackdrop" : "bg-light docLight border-start ",
        offcanvas: isDark ? "bg-dark" : " xlight border-start",
        title: isDark ? "text-white modified xTitle animated rollIn" : "xTitle text-dark animated rollIn",
    };

    const handleToggleClose = () => {
        if (props.onToggle) props.onToggle();
        else setLocalShow(false);
    };

    const handleToggleOpen = () => {
        if (props.onToggle) props.onToggle();
        else setLocalShow(true);
    };

    // RESTORED: Fetching data strictly loads data and does not force side-effect toggling
    const getXSpecials = () => {
        const db = getFirestore();
        spinner(true);
        const specialsRef = collection(db, "specials");
        const q = isPublicView ? query(specialsRef, where("isPrivate", "==", false)) : query(specialsRef);

        getDocs(q).then((snapshot) => {
            const data = snapshot.docs.map(doc => ({ ...doc.data(), id: doc.id }));
            const sortedData = data.sort((a, b) => {
                if (a.isASpecial === b.isASpecial) return 0;
                return a.isASpecial ? -1 : 1;
            });
            setXSpecials(sortedData);
            spinner(false);
        }).catch(err => {
            spinner(false);
            toast.error(err.message);
        });
    }

    const handleInitialClick = () => {
        getXSpecials();
        handleToggleOpen();
    };

    const handleScroll = (e) => {
        setShowScrollTop(e.target.scrollTop > 300);
    };

    const scrollToTop = () => {
        if (scrollRef.current) {
            scrollRef.current.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    const filtered = xSpecials.filter(s => s.name?.toLowerCase().includes(searchTerm.toLowerCase()));

    return (
        <>

            {isPublicView ? (
                
                    <Button onClick={handleInitialClick}>
                        <img src={glass} alt="Menu" className="thumb hoverX animated fadeInRight" />
                        <br />
                        <span>Specials</span>
                    </Button>
            ) : (
             
                    <Button variant={isDark ? "primary" : "outline-primary"} onClick={handleInitialClick} className="hoverX shadow-sm">
                        <span className="circle-btn centerCircle">🍷</span>Menu
                    </Button>
            )}

            <Offcanvas show={isCanvasOpen} onHide={handleToggleClose} placement="end"
                className={themeStyles.offcanvas}
                backdropClassName={themeStyles.backdrop}>
                <Offcanvas.Header className="border-bottom border-secondary border-opacity-25">
                    <div className="w-100">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h3 className={themeStyles.title} >Menu</h3>
                            <div className="d-flex gap-2 align-items-center">
                                {!isPublicView && <CreateDoc theme={theme} onSuccess={getXSpecials} />}
                                <CloseButton variant={isDark ? "white" : undefined} onClick={handleToggleClose} />
                            </div>
                        </div>
                        <Form.Control
                            type="search"
                            placeholder="🔎 Search menu or specials..."
                            className={isDark ? "glass-search" : "form-control shadow-sm"}
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                </Offcanvas.Header>
                <Offcanvas.Body className="custom-scrollbar position-relative" onScroll={handleScroll} ref={scrollRef}>
                    {filtered.map((x) => (
                        <XMenuList key={x.id} {...x} theme={theme} public={isPublicView} onDeleteSuccess={getXSpecials} />
                    ))}

                    {showScrollTop && (
                        <Button
                            variant="info"
                            className="position-fixed rounded-circle shadow-lg"
                            style={{ bottom: '20px', right: '20px', width: '45px', height: '45px', zIndex: 1000 }}
                            onClick={scrollToTop}
                        >
                            <FaArrowUp />
                        </Button>
                    )}
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
}